import home from './src/home.vue'
import ComplaintManagerView from './src/ComplaintManager/ComplaintManagerView.vue' //投诉管理列表
import ComplaintAcceptView from './src/ComplaintManager/ComplaintAcceptView.vue' //投诉受理列表
import ComplaintUndertakeView from './src/ComplaintManager/ComplaintUndertakeView.vue' //投诉承办列表
import ComplaintFinishView from './src/ComplaintManager/ComplaintFinishView.vue' //投诉办结列表
import ComplaintManagerInfo from './src/ComplaintManager/ComplaintManagerInfo.vue' //投诉详情
import ComplaintAllView from './src/ComplaintManager/ComplaintAllView.vue' //投诉管理列表(不带权限)
import ComplaintAllInfo from './src/ComplaintManager/ComplaintAllInfo.vue' //投诉详情(不带权限)
import ComplaintAllDealView from './src/ComplaintManager/ComplaintAllDealView.vue' //投诉管理列表(不带权限)
import ComplaintAllDealInfo from './src/ComplaintManager/ComplaintAllDealInfo.vue' //投诉详情(不带权限)
import ComplaintSimpleView from './src/ComplaintManager/ComplaintSimpleView.vue' //投诉查询简洁版(不带权限)
import ComplaintSimpleInfo from './src/ComplaintManager/ComplaintSimpleInfo.vue' //投诉详情简洁版(不带权限)


import ComplaintView from './src/ComplaintAdd/ComplaintView.vue' //投诉录入
import ComplaintInfo from './src/ComplaintAdd/ComplaintInfo.vue' //投诉录入详情

let views = {
    home,
    ComplaintManagerView,
    ComplaintManagerInfo,
    ComplaintAllView,
    ComplaintAllInfo,
    ComplaintAllDealView,
    ComplaintAllDealInfo,
    ComplaintSimpleView,
    ComplaintSimpleInfo,
    ComplaintAcceptView,
    ComplaintUndertakeView,
    ComplaintFinishView,
    ComplaintView,
    ComplaintInfo
};

export default views;